<template>
	<router-view></router-view>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
	async mounted() {
		if (!this.isLoggedIn) {
			await this.fetchCurrentUser();
		}

		if (this.isLoggedIn) {
			await this.fetchRealEstates();
		}

		if (this.findGetParameter('category')) {
			this.setCategory(parseInt(this.findGetParameter('category')));
			this.setCurrentStep(1);

			if (this.isLoggedIn) {
				this.showPopup('RealEstateChooser');
			} else {
				this.$router.push({ name: 'is-company' });
			}
		}
	},
	computed: {
		...mapGetters('auth', ['isLoggedIn', 'getCurrentUser']),
	},
	methods: {
		...mapActions('auth', ['fetchCurrentUser']),
		...mapActions(['fetchRealEstates']),
		...mapMutations(['setCategory', 'setCurrentStep', 'showPopup']),
		findGetParameter(parameterName) {
			let result = null,
				tmp = [];

			let items = location.search.substr(1).split('&');
			for (let index = 0; index < items.length; index++) {
				tmp = items[index].split('=');
				if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
			}
			return result;
		},
	},
};
</script>
